var _style, _path, _polygon, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag12Nb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF2B2D;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#002868;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8C2.6,42,0,39.4,0,36.3V5.7 C0,2.6,2.6,0,5.8,0z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64,17.3 25.5,17.3 25.5,0 18.1,0 18.1,17.3 0,17.3 0,24.7 18.1,24.7 18.1,42 25.5,42 25.5,24.7  64,24.7 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.4,
    y: 0,
    className: "st2",
    width: 5,
    height: 42
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 18.5,
    className: "st2",
    width: 64,
    height: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag12Nb);
export default __webpack_public_path__ + "static/media/flag_12_NB.d41e4e226981dd3eefae0927fce9bdae.svg";
export { ForwardRef as ReactComponent };